import { render, staticRenderFns } from "./ExamsListActionButton.vue?vue&type=template&id=59cb4bf6&scoped=true&"
import script from "./ExamsListActionButton.vue?vue&type=script&lang=js&"
export * from "./ExamsListActionButton.vue?vue&type=script&lang=js&"
import style0 from "./ExamsListActionButton.vue?vue&type=style&index=0&id=59cb4bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cb4bf6",
  null
  
)

export default component.exports